import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64d9f9aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"logo\" src=\"/logo.png\" alt=\"Logo\" height=\"64\" data-v-64d9f9aa><div class=\"title\" data-v-64d9f9aa><div class=\"name\" data-v-64d9f9aa>Lector Code Viewer</div><div class=\"author\" data-v-64d9f9aa>by <a href=\"https://www.primakurzyonline.cz\" data-v-64d9f9aa>PrimaKurzyOnline.cz</a></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import { ref, withDefaults, watch, computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})